import React, { Fragment, useState, useEffect } from 'react';
import classNames from 'classnames'
import T from 'i18n-react';
import './style.css'
import { useSelector } from 'react-redux';

const AssignmentBlock = ({ layoutType, scheduleCallClick, loaded }) => {
    const [headerKey, setHeaderKey] = useState(null)
    const case_state = useSelector(state => state.workflow?.case_state)
    const taxYear = useSelector(state => state.layout.taxYearTab);
    const assigned_tax_pro = case_state?.taxYears?.find(x => x.taxYear === Number(taxYear))?.assigned_tax_pro
    const ticketState = case_state?.taxYears?.find(x => x.taxYear === Number(taxYear))?.ticketState

    useEffect(() => {
        var hk = (layoutType === 'tablet' ? 'Dashboard.labels.YourTaxProTablet' : 'Dashboard.labels.YourTaxPro');
        if (hk !== headerKey) {
            setHeaderKey(hk)
        }
    }, [layoutType, headerKey, setHeaderKey])

    return (
        <div className={classNames('assignmentBlock')}>
            {layoutType === 'mobile' &&
                <div className='wf-wb-hr' />
            }
            <div className='assignmentBlockHeader'>{T.translate(headerKey)}</div>
            {((assigned_tax_pro === null || assigned_tax_pro === undefined || (assigned_tax_pro && ticketState?.includes("_COMPLETE"))) && loaded) &&
                <div className='assignmentBlockText'>{T.translate('Dashboard.labels.Unassigned')}</div>
            }
            {assigned_tax_pro && !ticketState?.includes("_COMPLETE") &&
                <Fragment>
                    <span>{assigned_tax_pro.name}</span>
                    {assigned_tax_pro.officeAddress &&
                        <Fragment>
                            <br />
                            <span>{assigned_tax_pro.officeAddress}</span>
                        </Fragment>
                    }
                    {assigned_tax_pro.officeAddress && assigned_tax_pro.officeCity &&
                        <span>{assigned_tax_pro.officeCity}</span>
                    }
                    {assigned_tax_pro.officePhone && layoutType === 'desktop' &&
                        <Fragment>
                            <span>{assigned_tax_pro.officePhone}</span>
                        </Fragment>
                    }
                    {assigned_tax_pro.officePhone && layoutType !== 'desktop' &&
                        <Fragment>
                            <a href={'tel:' + (assigned_tax_pro.officePhone || '').replace(/[^0-9.]/g, '')}>
                                <span>{assigned_tax_pro.officePhone}</span>
                            </a>
                        </Fragment>
                    }
                    {assigned_tax_pro.calendar_link &&
                        <a href={assigned_tax_pro.calendar_link} target="_blank" rel="noopener noreferrer"
                            onClick={() => scheduleCallClick(taxYear)}>
                            {T.translate('Dashboard.labels.CalendarLink', { TaxProName: assigned_tax_pro.name })}
                        </a>
                    }
                </Fragment>
            }   
        </div>
    )
}

export default AssignmentBlock;